module.exports = __webpack_public_path__ + "img/fig09.b4643824.jpg";